module.exports = __webpack_public_path__ + "static/media/roadsideemergency.090ad214.svg";